
import { Component, Prop, Vue } from 'vue-property-decorator';


@Component
export default class PathSidebar extends Vue {
    
    @Prop({required: true})
    pathTypes!: string[];

    @Prop({required: true})
    pathHeights!: string[]; 

}
